import { combineReducers } from "redux";
import { FETCH_NOTIFICATIONS_REQUEST, UNSEND_NOTIFICATIONS_REQUEST } from "./constants";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action, NotificationsState } from "./types";

function items(
  state: NotificationsState = {
    currentPage: 0,
    pageCount: 1,
    data: [],
  },
  action: Action
): NotificationsState {
  switch (action.type) {
    case getSuccessActionType(FETCH_NOTIFICATIONS_REQUEST):
      return action.payload;

    case UNSEND_NOTIFICATIONS_REQUEST: {
      return {
        ...state,
        data: state.data.map((notification) =>
          notification.id === action.data.notificationId
            ? { ...notification, isFetching: true }
            : notification
        ),
      };
    }

    case getSuccessActionType(UNSEND_NOTIFICATIONS_REQUEST):
      return {
        ...state,
        data: state.data.map((notification) =>
          notification.id === action.data.notificationId
            ? { ...action.payload, isFetching: false }
            : notification
        ),
      };

    case getFailureActionType(UNSEND_NOTIFICATIONS_REQUEST):
      return {
        ...state,
        data: state.data.map((notification) =>
          notification.id === action.data.notificationId
            ? { ...notification, isFetching: false }
            : notification
        ),
      };

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_NOTIFICATIONS_REQUEST):
    case getFailureActionType(FETCH_NOTIFICATIONS_REQUEST):
      return false;
    default:
      return state;
  }
}

export const notifications = combineReducers({ items, isFetching });
